import { useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'

const StateGraphRedirect = () => {
  const { projectId } = useParams<{ projectId: string }>()
  const navigate = useNavigate()

  useEffect(() => {
    if (projectId) {
      navigate(`/admin/projects/${projectId}/state-graph`, { replace: true })
    } else {
      navigate('/admin/projects', { replace: true })
    }
  }, [projectId, navigate])

  return null
}

export default StateGraphRedirect